<template>
  <div class="homeIndex">
    <!-- <a-layout theme="light"  style="background-color: #fff;">
      <a-layout-sider class="layout-sider" style="background: linear-gradient(180deg, #248ED0 0%, #30B9F5 100%);
      padding: 15px 0;box-sizing: border-box;min-height: 120vh;">
        <div>
          <router-link :to='{ "name": "home" }' style="margin:20px 0;">
            <div class="title">
              <div class="main-title">萧 银 案 件 管 理 系 统</div>
              <div class="min-title">XIAOYIN CASE MANAGEMENT SYSTEM</div>
            </div>
          </router-link>
        </div>
        <LeftMenu></LeftMenu>
      </a-layout-sider>
      <a-layout>
        <a-layout-header style="background: #fff;" >
          <Header></Header>
        </a-layout-header>
        <a-layout-content  style="padding: 20px;background-color: #F5F5F5;z-index:1;margin-top: 65px;">
          <div class="mains">
            <div class="bread">
              <a-breadcrumb>
                <a-breadcrumb-item v-for='(i, index) in bread' :key='index'>
                  <a href='javascript:void(0);' @click='went(i)'
                    :style="{ color: index == bread.length - 1 ? '#1D8BFE' : '#102B4B' }"><b>{{ i }} </b> </a>
                </a-breadcrumb-item>
              </a-breadcrumb>
            </div>
            <div class="contair">
              <router-view></router-view>
            </div>
          </div>
        </a-layout-content>
        <a-layout-footer  style="background-color: #F5F5F5;">
          <div class="footer">
            <div class="lett">
              <div class="p" style="margin-left:35px;">浙江萧银律师事务所</div>
              <a href="https://beian.miit.gov.cn" target="_blank"> <img src='../assets/img/gh.png' />浙ICP备2022024828号</a>
            </div>
          </div>
        </a-layout-footer>
      </a-layout>
    </a-layout> -->
    <div class="contairs">
      <div class="head">
        <router-link :to='{ "name": "home" }' style="margin-top:8px;">
          <img class="logo-name" src="https://xiaoyin-upload-new.oss-cn-hangzhou.aliyuncs.com/file/logo-name.png" height="50">
        </router-link>
        <div class="rt">
          <SlideMenu :curs='curs'></SlideMenu>
          <div class="my">
            <div class="name">
              <img src="../assets/img/user.png" alt="" />
              <span>{{ user.uname }}</span>
              <a-icon type="caret-down" />
            </div>
            <div class="drap">
              <router-link :to='{ "name": "accountGroup" }' v-if='user.id == 1' tag='a'>权限组管理</router-link>
              <router-link :to='{ "name": "userGroup" }' v-if='user.id == 1' tag='a'>用户组管理</router-link>
              <router-link :to='{ "name": "accountManage" }' v-if='user.id == 1' tag='a'>权限管理</router-link>
              <router-link :to='{ "name": "accountOperationLog" }' v-if='user.id == 1' tag='a'>操作日志</router-link>
              <router-link :to='{ "name": "accountLoginlist" }' tag='a'>登录日志</router-link>
              <a href="javascript:void(0);" @click='visible = true'>修改密码</a>
              <a href="javascript:void(0);" @click='out'>退出</a>
            </div>
          </div>
          <Repass :visible='visible' @close='visible = false;'></Repass>
        </div>
      </div>
      <div class="mains">
        <div class="bread">
          <a-breadcrumb>
            <a-breadcrumb-item v-for='(i, index) in bread' :key='index'>
              <a href='javascript:void(0);' @click='went(i)'
                :style="{ color: index == bread.length - 1 ? '#1D8BFE' : '#102B4B' }"><b>{{ i }} </b> </a>
            </a-breadcrumb-item>
          </a-breadcrumb>
        </div>
        <div class="contair">
          <router-view></router-view>
        </div>
      </div>
    </div>
    <div class="footer">
      <div class="lett">
        <div class="p" style="margin-left:35px;">浙江萧银律师事务所</div>
        <a href="https://beian.miit.gov.cn" target="_blank"> <img src='../assets/img/gh.png' />浙ICP备2022024828号</a>
      </div>
    </div>
  </div>
</template>
<script>
import SlideMenu from "@/components/slide"
import LeftMenu from "@/components/leftMenu"
import Header from "@/components/header"
import Repass from "./repass"
import { mapActions } from 'vuex'
import slideRouter from "@/components/slide/slide_n"
import { sLogOutUser } from "@/server/api";
export default {
  data() {
    return {
      curs: -1,
      visible: false,
      bread: []
    };
  },
  created() {
    this.getKey()
    this.router()
  },
  components: {
    SlideMenu,LeftMenu,Header,
    Repass
  },
  computed: {
    user() {
      return this.$store.state.user
    }
  },
  methods: {
    went(i) {
      let slideMenu = []
      slideRouter.map(ele => {
        slideMenu.push({ title: ele.title, link: ele.link })
        if (ele.child) {
          ele.child.map(s => {
            slideMenu.push({ title: s.title, link: s.link })
          })
        }
      })
      const routerLink = slideMenu.filter(ele => {
        return ele.title === i
      })
      if (routerLink.length > 0) {
        this.$router.push({ name: routerLink[0].link })
      }
    },
    ...mapActions({
      getKey: 'Dictionary/getKey'
    }),
    router() {
      let route = this.$route;
      let meta = route.meta;
      this.curs = meta.curs;
      let bread = meta.title.split(",")
      if (meta.bet) {
        bread.push(route.params.id > 0 ? "修改分期" : "添加分期")
      }
      this.bread = bread
    },
    out() {
      sLogOutUser().then(res => { })//退出登录
      this.$message.success({ content: '退出成功', key: 'updatable' });
      localStorage.clear();
      this.$store.dispatch("setuser", {})
      this.$router.replace({ name: 'login' })
    }
  },
  watch: {
    $route(to, from) {
      this.router();
    }
  },
};
</script>

<style lang="less">
#components-layout-demo-basic {
  text-align: center;
}
#components-layout-demo-basic .ant-layout-header {
  background: #7dbcea !important;
  color: #fff;
}
#components-layout-demo-basic .ant-layout-sider {
  background: #3ba0e9;
  color: #fff;
  line-height: 120px;
}
#components-layout-demo-basic .ant-layout-content {
  background: rgba(16, 142, 233, 1);
  color: #fff;
  min-height: 120px;
  line-height: 120px;
}
#components-layout-demo-basic > .ant-layout {
  margin-bottom: 48px;
}
#components-layout-demo-basic > .ant-layout:last-child {
  margin: 0;
}

.homeIndex {
  min-width: 1280px;
  background: url("../assets/img/tp.jpg") no-repeat center top #f4f5f9;

  .title {
    text-align: center;
    color: #fff;
    margin: 20px auto 30px;

    .main-title {
      font-size: 21px;
      font-weight: 900;
    }

    .min-title {
      font-size: 10px;
      font-weight: 500;
      letter-spacing: 1px;
    }
  }

  .open {
    display: none;
  }

  .footer {
    margin-top: 20px;
    width: 100%;
    height: 92px;
    opacity: 0.5;
    display: flex;
    align-items: center;
    flex-direction: column;
    justify-content: center;
    font-size: 14px;
    color: #222121;
    line-height: 26px;

    a {
      font-size: 14px;
      color: #222121;
      display: flex;
      align-items: center;
      line-height: 26px;

      img {
        margin-right: 10px;
      }

      &:hover {
        color: #128aff;
      }
    }
  }

  min-height: 100vh;

  .contairs {
    padding: 0 80px 20px;
  }

  .head {
    height: 104px;
    position: relative;
    z-index: 111;
    display: flex;
    justify-content: space-between;
    box-sizing: border-box;
    padding-top: 20px;
    align-items: flex-start;

    .rt {
      color: #fff;
      cursor: pointer;
      display: flex;
      padding-top: 20px;
    }
  }

  .mains {
    overflow: hidden;
  }

  .contair {}

  .bread {
    height: 60px;
    width: 100%;
    display: flex;
    align-items: center;
    box-sizing: border-box;
    padding: 0 20px;
    background: #fff;
    box-shadow: 0px 2px 10px 0px rgba(0, 0, 0, 0.06);
    position: relative;
    z-index: 11;
  }

  .rt {
    position: relative;

    .my {
      font-size: 16px;

      .name {
        font-weight: 500;
        padding-bottom: 30px;
        line-height: 22px;
        display: flex;
        align-items: center;

        img {
          margin-right: 6px;
        }
      }
    }
  }

  .drap {
    width: 104px;
    // height: 80px;
    background: #fff;
    box-shadow: 0 0 3px #ccc;
    position: absolute;
    right: 0;
    top: 62px;
    display: none;

    a {
      font-size: 14px;
      display: block;
      line-height: 40px;
      padding-left: 20px;
      border-bottom: 1px solid #f8f8f8;
      color: #696c76;

      &:hover {
        color: #128aff;
      }
    }
  }

  .head {
    .my {
      margin-left: 40px;

      span {
        margin-right: 10px;
      }

      &:hover {
        .drap {
          display: block;
        }
      }
    }
  }
}

/* 全局滚动条样式 */
::-webkit-scrollbar {
  width: 16px;
  /* 垂直滚动条宽度 */
  height: 16px;
  /* 水平滚动条高度 */
  background-color: transparent;
}

/* 滚动条轨道 */
::-webkit-scrollbar-track {
  background-color: transparent;
  border-radius: 8px;
  margin: 4px;
}

/* 滚动条滑块 */
::-webkit-scrollbar-thumb {
  background-color: rgba(0, 0, 0, 0.4);
  border-radius: 8px;
  border: 4px solid transparent;
  background-clip: content-box;
  min-height: 40px;
}

/* 滚动条滑块悬停状态 */
::-webkit-scrollbar-thumb:hover {
  background-color: rgba(0, 0, 0, 0.6);
}

/* 滚动条滑块激活状态 */
::-webkit-scrollbar-thumb:active {
  background-color: rgba(0, 0, 0, 0.4);
}

/* 滚动条角落 */
::-webkit-scrollbar-corner {
  background-color: transparent;
}
</style>